import {AnnotatedSubject, INote, NoteApi} from "@betrue/shared/interfaces";
import {useState} from "react";
import {gql, useLazyQuery, useMutation} from "@apollo/client";
import {useResult} from "./results";
import {BASE_ENTITY_FIELDS} from "./base-fields";

export const CORE_NOTE_FIELDS = gql`
  fragment CoreNoteField on NoteModel{
    ${BASE_ENTITY_FIELDS}
    content
    subject
    subjectId
  }
`;

const GET_NOTES_BY_SUBJECT = gql`
  ${CORE_NOTE_FIELDS}
  query findNoteForSubject($subject: AnnotatedSubject!, $subjectId: String!) {
    findNoteForSubject(subject: $subject,subjectId: $subjectId) {
      ...CoreNoteField
      updatedAt
      owner {
        ${BASE_ENTITY_FIELDS}
        firstName
        lastName
      }
    }
  }
`

const ADD_NOTE = gql`
  ${CORE_NOTE_FIELDS}
  mutation addNote($note: NoteModelInput!) {
    addNote(note: $note) {
      ...CoreNoteField
      updatedAt
      owner {
        ${BASE_ENTITY_FIELDS}
        firstName
        lastName
      }
    }
  }
`


export const useNote = <T = INote | INote[]>(initial?: T): [T, NoteApi] => {
  const [result, setResult] = useState<T>(initial);
  const notesBySubject = useResult(useLazyQuery(GET_NOTES_BY_SUBJECT, {fetchPolicy: "cache-and-network"}), setResult)
  const addNote = useResult(useMutation(ADD_NOTE, {}), setResult)

  return [
    result,
    {
      addNote(note: INote) {
        addNote({
          variables: {
            note: note
          }
        })
      },
      removeNote(noteId: string) {
        console.error('not implemented')

      },
      updateNote(noteId: string, content: string) {
        console.error('not implemented')
      },
      findNoteForSubject(subject: AnnotatedSubject, subjectId: string) {
        notesBySubject({
          variables: {
            subject:subject,
            subjectId:subjectId
          }
        })
      }
    }]
}
